import React from 'react';

export default function AnnouncementBar() {
  return (
    <div className="bg-[black] py-3 px-2 md:px-0 text-center">
      <h5 className="text-sm md:text-xl font-medium text-white ">
        100% Money Back Guarantee On Prepaid Orders
      </h5>
    </div>
  );
}